"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var dealersListStyles_1 = require("./dealersListStyles");
var react_1 = require("react");
var DealerDetails_1 = require("../dealerDetails/DealerDetails");
var DealersList = function (_a) {
    var dealers = _a.dealers, selectedDealerId = _a.selectedDealerId, selectDealerId = _a.selectDealerId, disableDealerSelection = _a.disableDealerSelection;
    var styles = dealersListStyles_1.default();
    return (<core_1.List className={styles.list}>
      {Array.isArray(dealers) &&
        dealers.map(function (dealer, index) { return (<core_1.Box key={index}>
            <core_1.ListItem key={dealer.externalId} data-test={"dealer:listItem:card_" + dealer.externalId}>
              <DealerDetails_1.default dealer={dealer} orderId={index} isSelected={selectedDealerId === dealer.externalId} selectDealerId={selectDealerId} disableDealerSelection={disableDealerSelection}/>
            </core_1.ListItem>
            <core_1.Divider />
          </core_1.Box>); })}
    </core_1.List>);
};
exports.default = DealersList;
